// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Axios from 'axios'
import store from './store/index.js'
import 'element-ui/lib/theme-chalk/index.css';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';


Axios.defaults.baseURL = 'https://www.tindoe.com/apiserver'
// Axios.defaults.baseURL = 'https://374jrus75612.vicp.fun'
// Axios.defaults.baseURL = 'http://wr3qcb.natappfree.cc'
Axios.interceptors.response.use(res => {
    return res.data
  },
  error => {
    //alert('请求失败，请稍后重试！')
    return Promise.reject(error)
  }
)
Vue.prototype.$https = Axios
Vue.use(ElementUI);
Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js